export default function({
  data,
  xCol,
  yCol
}) {
  let col = this.col === 'y' ? yCol : xCol
  return data.map(d => {
    return d[col]
  })
}



/** WEBPACK FOOTER **
 ** ./src/utils/d3/get_ordinal_domain.js
 **/